import React from 'react';
import { useParams } from 'react-router-dom';
import EquipmentKycDetail from './EquipmentKycDetail';

export default function EquipmentKycDetailPage() {
  const { submissionId } = useParams();
  return <EquipmentKycDetail id={submissionId} />;
}
